import React, { } from "react";
import Box from "@mui/material/Box";
import { FilterTextField } from "@ntg/components/text-fields";
import { useTheme } from "@mui/material/styles";

interface DashboardToolbarProps {
    onValueChange: (value: string) => void;
    SearchTerm: string;
}

export default function BoatTypeToolbar(props: DashboardToolbarProps) {
    const theme = useTheme();
    return (
        <div
            style={{
                alignItems: "center",
                display: "flex",
                // gap: theme.spacing(2),
                justifyContent: "flex-start",
                width: "100%",
            }}
        >
            <FilterTextField
                variant="outlined"
                className="cs-control"

                onFilterApply={(value: string): void => {
                    props.onValueChange(value);
                }}
                sx={{

                    minWidth: 0,
                    order: 2,
                    width: "1fr",
                    }}

                initialValue={props.SearchTerm}
            />
        </div>
    );
}